import {
  Button,
  Divider,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { addContactV2Style } from "./AddContactV2Style";
import { LEAD_TYPES, PHONE_TYPES } from "../../constants/CoreConstants";
import { IconList } from "../addContact/IconList";
import { DeleteForever } from "@material-ui/icons";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { getState } from "../addContact/Utils";
import { US_STATE_LIST } from "../addContact/CoreConstants";
import { useSelector } from "react-redux";
import { PlusIcon } from "../common/Icons";
import BasicFormControlWithLabelV2 from "../custom/BasicFormControlWithLabelV2";
import BasicInput from "../custom/BasicInput";
import BasicSelectWithSearch from "../custom/BasicSelectWithSearch";
import BasicSelect from "../custom/BasicSelect";
import {BasicMaskedInput} from "../GlobalAddDealModalV3/GlobalAddDealModalStyles";

const ContactPersonalInfo = ({
  personalInfoRef,
  contactForm,
  setContactForm,
  handleChangeDynamicInput,
  appendNumber,
  removeMultiField,
  appendEmail,
  handleInputField,
  handleAddress,
  showAddress,
  toggleAddress,
  value,
  makeAddress,
}) => {
  const { leadSourceOptions, pipelineOptions, stageOptions } = useSelector(
    (state) => state.addContactOptionReducer
  );
  const classes = addContactV2Style();
  const GOOGLE_API_KEY = process.env.REACT_APP_MAP_KEY;
  const placeholderColor = "#929da9";
  const activeColor = "#36454F";
  const [updatedStageOptions, setUpdatedStageOptions] = useState([]);

  useEffect(() => {
    setUpdatedStageOptions(stageOptions);
  }, [stageOptions]);

  useEffect(() => {
    const filteredStageOptions = stageOptions.filter((item) => {
      return item.pipeline_id === contactForm.pipeline_id;
    });
    setUpdatedStageOptions(filteredStageOptions);
  }, [contactForm.pipeline_id]);

  return (
    <Grid
      container
      spacing={2}
      style={{ paddingInline: 5, marginBottom: "48px" }}
    >
      <Grid item xs={12}>
        <div
          ref={personalInfoRef}
          data-section="Personal Info"
          style={{ width: "100%" }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                paddingRight: "10px",
              }}
            >
              <Typography variant="body2" className={classes.titleStyle}>
                Personal Info
              </Typography>
            </div>

            <div style={{ width: "100%" }}>
              <Divider />
            </div>
          </div>
        </div>
      </Grid>
      <div style={{ 
        width: "100%", 
        border: "1px solid #ccc",
        borderRadius: "8px",
        padding: "16px",
        margin: '8px'
        }}
      >
        <Grid container spacing={2}>
           <Grid item xs={12} md={3}>
               <BasicFormControlWithLabelV2
                   label={'Lead Source'}
                   fullWidth
                   options={leadSourceOptions}
                   mapping={{
                       label: "source_title",
                       value: "id",
                   }}
                   defaultText="Please Select"
                   placeholderText='Search lead source...'
                   value={contactForm.selected_source}
                   onChange={(event) => {
                       setContactForm((prev) => ({
                           ...prev,
                           selected_source: event.target.value,
                       }));
                   }}
                   component={BasicSelectWithSearch}
                   sx={{
                       '& .MuiInputBase-root': {
                           marginTop: 0,
                       },
                       '& .MuiInputBase-input': {
                           border: 'none !important'
                       }
                   }}
               />
           </Grid>

          <Grid item xs={12} md={3}>
              <BasicFormControlWithLabelV2
                  label={'Lead Type'}
                  fullWidth
                  name="lead_type"
                  options={LEAD_TYPES}
                  defaultText="Please Select"
                  value={contactForm.lead_type}
                  onChange={(event) => {
                      setContactForm((prev) => ({
                          ...prev,
                          lead_type: event.target.value,
                      }));
                  }}
                  mapping={{
                      label: "label",
                      value: "value",
                  }}
                  component={BasicSelect}
                  sx={{
                      '& .MuiInputBase-root': {
                          marginTop: 0,
                      },
                      '& .MuiInputBase-input': {
                          border: 'none !important'
                      }
                  }}
              />
          </Grid>

          <Grid item xs={12} md={3}>
              <BasicFormControlWithLabelV2
                  label={'Pipeline'}
                  fullWidth
                  name="pipeline"
                  options={pipelineOptions}
                  defaultText="Please Select"
                  value={contactForm.pipeline_id}
                  onChange={(event) => {
                      setContactForm((prev) => ({
                          ...prev,
                          pipeline_id: event.target.value,
                      }));
                  }}
                  mapping={{
                      label: "title",
                      value: "id",
                  }}
                  component={BasicSelect}
                  sx={{
                      '& .MuiInputBase-root': {
                          marginTop: 0,
                      },
                      '& .MuiInputBase-input': {
                          border: 'none !important'
                      }
                  }}
              />
          </Grid>

          <Grid item xs={12} md={3}>
              <BasicFormControlWithLabelV2
                  label={'Stage'}
                  fullWidth
                  name="stage"
                  options={updatedStageOptions}
                  defaultText="Please Select"
                  value={contactForm.stage_id}
                  onChange={(event) => {
                      setContactForm((prev) => ({
                          ...prev,
                          stage_id: event.target.value,
                      }));
                  }}
                  mapping={{
                      label: "stage",
                      value: "id",
                  }}
                  component={BasicSelect}
                  sx={{
                      '& .MuiInputBase-root': {
                          marginTop: 0,
                      },
                      '& .MuiInputBase-input': {
                          border: 'none !important'
                      }
                  }}
              />
          </Grid>

          <Grid item xs={12} md={6}>
              <BasicFormControlWithLabelV2
                  label={'First Name'}
                  name="firstName"
                  fullWidth
                  value={contactForm.first_name}
                  onChange={(event) => {
                      setContactForm((prev) => ({
                          ...prev,
                          first_name: event.target.value,
                      }));
                  }}
                  component={BasicInput}
                  sx={{
                      '& .MuiInputBase-root': {
                          marginTop: 0,
                      },
                      '& input': {
                          border: 'none !important'
                      }
                  }}
              />
          </Grid>

          <Grid item xs={12} md={6}>
              <BasicFormControlWithLabelV2
                  label={'Last Name'}
                  name="firstName"
                  fullWidth
                  value={contactForm.last_name}
                  onChange={(event) =>
                      setContactForm((prev) => ({
                          ...prev,
                          last_name: event.target.value,
                      }))
                  }
                  component={BasicInput}
                  sx={{
                      '& .MuiInputBase-root': {
                          marginTop: 0,
                      },
                      '& input': {
                          border: 'none !important'
                      }
                  }}
              />
          </Grid>

      {contactForm.numbers.map((number, index) => (
        <Grid item xs={12} key={index}>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6} className="mask-numbr-input">
                  <BasicFormControlWithLabelV2
                      label={'Phone Number'}
                      fullWidth
                      mask={[
                          "+",
                          /\d/,
                          " ",
                          "(",
                          /\d/,
                          /\d/,
                          /\d/,
                          ")",
                          " ",
                          /\d/,
                          /\d/,
                          /\d/,
                          "-",
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                      ]}
                      className={`${classes.phoneNumberInput} MuiInputBase-input`}
                      // guide={true}
                      // keepCharPositions={true}
                      id={"number-input-field" + index}
                      onChange={(event) => {
                          handleChangeDynamicInput(
                              "numbers",
                              "number",
                              event.target.value,
                              index
                          );
                      }}
                      value={number.number}
                      component={BasicMaskedInput}
                      sx={{
                          '& .MuiInputBase-root': {
                              marginTop: 0,
                          },
                          '& input': {
                              border: 'none !important'
                          }
                      }}
                  />
              </Grid>
              <Grid item xs={6}>
                  <div style={{ display: "flex", gap: "10px" }}>
                      <BasicSelect
                          fullWidth
                          name="numberState"
                          defaultText="Please Select"
                          options={PHONE_TYPES}
                          value={number.number_state}
                          onChange={(event) => {
                              handleChangeDynamicInput(
                                  "numbers",
                                  "number_state",
                                  event.target.value,
                                  index
                              );
                          }}
                          mapping={{
                              label: "label",
                              value: "value",
                          }}
                      />

                      {index === 0 ? (
                          <div
                              className={classes.addButtonStyle}
                              onClick={appendNumber}
                          >
                              <PlusIcon fill="#FFF" />
                          </div>
                      ) : (
                          <IconButton
                              size="small"
                              className=""
                              style={{ marginLeft: "5px" }}
                              onClick={() => {
                                  removeMultiField("numbers", index);
                              }}
                          >
                              <DeleteForever color="error" />
                          </IconButton>
                      )}
                  </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ))}

      {contactForm.emails.map((email, index) => (
        <Grid item xs={12} key={index}>
          <div style={{ display: "flex", gap: "10px" }}>
              <BasicFormControlWithLabelV2
                  label={'Email'}
                  fullWidth
                  type="email"
                  name="email"
                  value={email.email}
                  onChange={(event) => {
                      handleChangeDynamicInput(
                          "emails",
                          "email",
                          event.target.value,
                          index
                      );
                  }}
                  component={BasicInput}
                  sx={{
                      '& .MuiInputBase-root': {
                          marginTop: 0,
                      },
                      '& input': {
                          border: 'none !important'
                      }
                  }}
              />
            {index === 0 ? (
              <div className={classes.addButtonStyle} onClick={appendEmail}>
               <PlusIcon fill="#FFF" />
              </div>
            ) : (
              <IconButton
                size="small"
                className=""
                style={{ marginLeft: "5px" }}
                onClick={() => {
                  removeMultiField("emails", index);
                }}
              >
                <DeleteForever color="error" />
              </IconButton>
            )}
          </div>
        </Grid>
      ))}

      <Grid item xs={12} md={6}>
          <BasicFormControlWithLabelV2
              label={'Date of Birth'}
              name="dateOfBirth"
              type="date"
              fullWidth
              style={{color: contactForm.birth_date ? activeColor : placeholderColor}}
              value={contactForm.birth_date || ''}
              onChange={(event) =>
                  setContactForm((prev) => ({
                      ...prev,
                      birth_date: event.target.value,
                  }))
              }
              component={BasicInput}
              sx={{
                  '& .MuiInputBase-root': {
                      marginTop: 0,
                  },
                  '& input': {
                      border: 'none !important'
                  }
              }}
          />
      </Grid>
        <Grid container spacing={2} style={{ paddingInline: 5 }}>
        {showAddress ? (
          <Grid item xs={12} style={{ paddingBottom: 0 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "2px",
                marginBottom: "8px"
              }}
            >
              <Button
                variant="contained"
                className={classes.manualEntryButton}
                onClick={toggleAddress}
                style={{
                  margin: 0,
                  padding: "6px 14px",
                  textTransform: "none",
                }}
              >
                Address Search
              </Button>
            </div>
          </Grid>
        ) : (
          <Grid item xs={12}>
            <div
              className={classes.googlePlacesAutocomplete}
              style={{ margin: 0 }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                  paddingTop: "4px",
                }}
              >
                <div style={{ width: "100%" }}>
                    <BasicFormControlWithLabelV2
                        label={'Address Search'}
                        fullWidth
                        apiKey={GOOGLE_API_KEY}
                        autoFocus={false}
                        autocompletionRequest={{
                            componentRestrictions: {
                                country: ["us", "ca"],
                            },
                        }}
                        selectProps={{
                            value,
                            onChange: async (e) => {
                                await handleAddress(e.value);
                            },
                            placeholder: (
                                <span
                                    style={{
                                        color: "rgb(8 40 82 / 42%)",
                                        fontSize: "15px",
                                    }}
                                >
                                  Start typing address here…
                                </span>
                            ),
                            classNamePrefix: "my-google-places-autocomplete",
                        }}
                        component={GooglePlacesAutocomplete}
                        sx={{
                            '& .my-google-places-autocomplete__control': {
                                border: 'none !important'
                            },
                            '& .my-google-places-autocomplete__control--is-focused, .my-google-places-autocomplete__control--menu-is-open' : {
                                boxShadow: 'none !important'
                            }
                        }}
                    />
                </div>
                <div style={{ width: "2px", paddingTop: "8px" }}>
                  <span
                    style={{
                      position: "relative",
                      marginLeft: "-80px",
                    }}
                  >
                    {IconList.locationSVG}
                  </span>
                </div>

                <Button
                  variant="contained"
                  className={classes.manualEntryButton}
                  onClick={toggleAddress}
                  style={{
                    whiteSpace: "nowrap",
                    paddingLeft: "14px",
                    paddingRight: "14px",
                    textTransform: "none",
                  }}
                >
                  Manual
                </Button>
              </div>
            </div>
          </Grid>
        )}
        {showAddress ? (
          <>
            <Grid item xs={12} style={{ paddingTop: "0px" }}>
                <BasicFormControlWithLabelV2
                    label={'Address'}
                    fullWidth
                    value={contactForm.address}
                    onChange={(event) =>
                        handleInputField("address", event.target.value)
                    }
                    component={BasicInput}
                    sx={{
                        '& .MuiInputBase-root': {
                            marginTop: 0,
                        },
                        '& input': {
                            border: 'none !important'
                        }
                    }}
                />
            </Grid>
            <Grid item xs={6}>
                <BasicFormControlWithLabelV2
                    label={'City'}
                    fullWidth
                    value={contactForm.city}
                    onChange={(event) =>
                        handleInputField("city", event.target.value)
                    }
                    component={BasicInput}
                    sx={{
                        '& .MuiInputBase-root': {
                            marginTop: 0,
                        },
                        '& input': {
                            border: 'none !important'
                        }
                    }}
                />
            </Grid>

            <Grid item xs={6}>
                <BasicFormControlWithLabelV2
                    label={'State'}
                    fullWidth
                    name="state"
                    defaultText="Please Select"
                    options={US_STATE_LIST}
                    value={getState(contactForm.state) ? contactForm.state : ""}
                    onChange={(event) => {
                        handleInputField("state", event.target.value)
                    }}
                    mapping={{
                        label: "label",
                        value: "value",
                    }}
                    component={BasicSelect}
                    sx={{
                        '& .MuiInputBase-root': {
                            marginTop: 0,
                        },
                        '& .MuiInputBase-input': {
                            border: 'none !important'
                        }
                    }}
                />
            </Grid>
            <Grid item xs={6}>
                <BasicFormControlWithLabelV2
                    label={'Country'}
                    fullWidth
                    value={contactForm.country}
                    onChange={(event) =>
                        handleInputField("country", event.target.value)
                    }
                    component={BasicInput}
                    sx={{
                        '& .MuiInputBase-root': {
                            marginTop: 0,
                        },
                        '& input': {
                            border: 'none !important'
                        }
                    }}
                />
            </Grid>

            <Grid item xs={6}>
                <BasicFormControlWithLabelV2
                    label={'Zip Code'}
                    fullWidth
                    value={contactForm.zip}
                    onChange={(event) =>
                        handleInputField("zip", event.target.value)
                    }
                    component={BasicInput}
                    sx={{
                        '& .MuiInputBase-root': {
                            marginTop: 0,
                        },
                        '& input': {
                            border: 'none !important'
                        }
                    }}
                />
            </Grid>
          </>
        ) : (
          <Grid item xs={12} style={{ paddingTop: 0 }}>
            <div style={{ fontSize: "12px" }}>{makeAddress()}</div>
          </Grid>
        )}
      </Grid>
        </Grid>
      </div>

    </Grid>
  );
};

export default ContactPersonalInfo;
